import i18n from '@/plugins/i18n'

export type Translation = {
  en: Record<string, string>,
  fi: Record<string, string>,
  se: Record<string, string>,
}


export function getTranslationRaw (translation: Translation | string): any {
  if (
    typeof translation === 'string' ||
    translation instanceof String
  ) {
    return translation
  }

  if (!translation) return null
  // If text has localized
  const localizedText = translation[i18n.locale]
  if (localizedText) return localizedText

  // If not localized title return fallback
  switch (i18n.locale) {
    case 'en':
      return translation['fi'] || translation['se']
    case 'fi':
      return translation['en'] || translation['se']
    case 'se':
      return translation['en'] || translation['fi']
  }

  return null
}

export function getTranslation (translation: Translation | string) {
  return (getTranslationRaw(translation) || '').replace(/&nbsp;/g, ' ')
}